import { generateBooleanSchema, generateRootObjectSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { ImageParticleSpec } from "components/cards/particles/YinzCam";

export const specification = new BaseAtomSpec("Image Card", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  image: ImageParticleSpec.generateSchema("Image", "The image."),
  popupImageDefaults: ImageParticleSpec.generateSchema("Popup Image Defaults", "Styling and properties to apply to the popup image vs. the one embedded on the page.", {
    defaultValues: { container: { fillWidth: true, fillHeight: true }, role: 'none' },
    uneditableFields: { source: true, alt: true }
  }),
  enablePopupOnClick: generateBooleanSchema("Enable Popup on Click", ""),
}));
